import { OpenUpHttpClient } from "@src/api/OpenUpHttpClient";
import { VideoCalling } from "@src/api/v1/VideoCalling";

const videoCalling = new VideoCalling(OpenUpHttpClient);

export const getToken = (roomId: string) =>
  roomId ? videoCalling.getAcsToken({ roomId }) : null;

export const whoElseIsInCall = (roomId: string) =>
  roomId ? videoCalling.getWhoElseInCall({ roomId }) : [];
